/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Step_ExpandInputs */

const en_admin_ai_chat_step_expand = /** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand reasoning`)
};

const de_admin_ai_chat_step_expand = /** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begründung ausklappen`)
};

const es_admin_ai_chat_step_expand = /** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar razonamiento`)
};

const fr_admin_ai_chat_step_expand = /** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le raisonnement`)
};

const nl_admin_ai_chat_step_expand = /** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redenering uitvouwen`)
};

/** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */
const it_admin_ai_chat_step_expand = en_admin_ai_chat_step_expand;

/** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_step_expand = en_admin_ai_chat_step_expand;

/** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */
const pl_admin_ai_chat_step_expand = en_admin_ai_chat_step_expand;

/** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */
const hu_admin_ai_chat_step_expand = en_admin_ai_chat_step_expand;

/** @type {(inputs: Admin_Ai_Chat_Step_ExpandInputs) => LocalizedString} */
const ro_admin_ai_chat_step_expand = en_admin_ai_chat_step_expand;

/**
* | output |
* | --- |
* | "Expand reasoning" |
*
* @param {Admin_Ai_Chat_Step_ExpandInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_step_expand = /** @type {((inputs?: Admin_Ai_Chat_Step_ExpandInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Step_ExpandInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_step_expand(inputs)
	if (locale === "de") return de_admin_ai_chat_step_expand(inputs)
	if (locale === "es") return es_admin_ai_chat_step_expand(inputs)
	if (locale === "fr") return fr_admin_ai_chat_step_expand(inputs)
	if (locale === "nl") return nl_admin_ai_chat_step_expand(inputs)
	if (locale === "it") return it_admin_ai_chat_step_expand(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_step_expand(inputs)
	if (locale === "pl") return pl_admin_ai_chat_step_expand(inputs)
	if (locale === "hu") return hu_admin_ai_chat_step_expand(inputs)
	return ro_admin_ai_chat_step_expand(inputs)
});
export { admin_ai_chat_step_expand as "admin.ai_chat.step_expand" }